<div class="PGMassPublishModal">
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-mass-publish-modal.title' | locTranslate }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="dismissModal()" [disabled]="isClosing">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body">
        <div>
            <label class="mb-1">
                <b class="d-block pb-2">{{ 'pg-mass-publish-modal.publish-on' | locTranslate }}</b>
                <app-pg-select [options]="publishOnOptions" [(ngModel)]="publishOnValue" (ngModelChange)="onPublishOnValueChange()" [required]="true" [readonly]="isClosing"></app-pg-select>
            </label>
        </div>

        <div>
        @if (resourceData != null && resourceData.length > 0) {
            <table class="table">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <thead>
                    <tr>
                        <th>
                            <input type="checkbox" [(ngModel)]="selectAll" (ngModelChange)="onSelectAllChange()" [disabled]="isClosing"/>
                        </th>
                        <th [attr.colspan]="2">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <b>{{ 'pg-mass-publish-modal.select-all' | locTranslate }}</b>
                                </div>
                                <div class="PGMassPublishModal-Count">
                                    @if (isLoadingResource) {
                                        <app-pg-loading [isSmall]="true"></app-pg-loading>
                                    }
                                    @else {
                                        {{ 'pg-mass-publish-modal.items' | locTranslate:'count':resourceData.length }}
                                    }
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                @for (element of resourceData; track element) {
                    <tr>
                        <td>
                            <input type="checkbox" [ngModel]="isElementSelected(element)" (ngModelChange)="setElementSelected(element, $event)" [disabled]="isClosing || element.disabled"/>
                        </td>
                        <td class="{{element.disabled ? 'text-muted' : ''}}">
                            {{element.id}}
                        </td>
                        <td class="{{element.disabled ? 'text-muted' : ''}}" [innerHTML]="element.label"></td>
                    </tr>
                }
                </tbody>
            </table>
        }
        @if (!isLoadingResource && resourceData.length == 0) {
            <div class="text-muted py-2">{{ 'pg-mass-publish-modal.no-items' | locTranslate }}</div>
        }
        @if (isLoadingResource) {
            <app-pg-loading></app-pg-loading>
        }
        </div>
    </div>

    <div class="modal-footer text-right">
        <button class="btn btn-primary" (click)="doMassPublish()" [disabled]="isClosing">{{ 'pg-mass-publish-modal.button-publish' | locTranslate }}</button>
    </div>
</div>
